import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

import { Funciones } from "../../shared/funciones";

@Component({
	selector: 'app-page404',
	templateUrl: './page404.component.html'
})
export class Page404Component implements OnInit {

	constructor(
		private location: Location,
		private funciones: Funciones
		) { }

	goBack(){
		this.location.back();
	}

	ngOnInit() {
		this.funciones.changeMetaDesc();
		this.funciones.changeTitle('Pagina no encontrada');
	}

}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/page404.component.ts